(() => {
  function initProductVariantUI(root = document) {
    // per ogni form prodotto nella pagina
    const forms = root.querySelectorAll('form[action*="/cart/add"]');
    forms.forEach((form) => {
      const sectionId = form.dataset.sectionId || form.getAttribute('data-section-id');
      if (!sectionId) return;

      const skuWrap = document.getElementById(`SkuWrap-${sectionId}`);
      const skuValue = document.getElementById(`SkuValue-${sectionId}`);

      // trova i select varianti (dropdown) dentro il form
      const variantSelects = form.querySelectorAll('select[name^="options"], select[name="id"]');

      // 1) Nascondi label "SCEGLI LA MISURA" se non serve (una sola opzione reale)
      // (funziona anche se la variante è gestita tramite select "id")
      const optionSelect = form.querySelector('select[name^="options"]');
      if (optionSelect) {
        const realOptions = Array.from(optionSelect.options).filter(o => o.value && !o.disabled);
        if (realOptions.length <= 1) {
          const wrapper = optionSelect.closest('.product-form__input') || optionSelect.parentElement;
          if (wrapper) wrapper.style.display = 'none';
        }
      }

      // 2) Aggiorna SKU leggendo la variante selezionata dall'evento Dawn (se presente)
      document.addEventListener('variant:change', (event) => {
        const v = event.detail && event.detail.variant;
        if (!v) return;

        // assicurati che l'evento arrivi da questo form
        const eventForm = event.target.closest('form[action*="/cart/add"]');
        if (eventForm !== form) return;

        if (!skuWrap || !skuValue) return;

        if (v.sku) {
          skuValue.textContent = v.sku;
          skuWrap.style.display = '';
        } else {
          skuValue.textContent = '';
          skuWrap.style.display = 'none';
        }
      });

      // 3) Fallback: se per qualche motivo variant:change non parte,
      // ricarica la pagina quando cambia la variante id (non ideale, ma sicuro)
      // (lo lasciamo disattivato di default)
      // const idSelect = form.querySelector('select[name="id"]');
      // if (idSelect) idSelect.addEventListener('change', () => location.reload());
    });
  }

  // init normale
  document.addEventListener('DOMContentLoaded', () => initProductVariantUI());

  // supporto Shopify editor (quando cambi in Customize)
  document.addEventListener('shopify:section:load', (e) => initProductVariantUI(e.target));
})();
